<button
  [routerLink]="purchaseStatusLink()"
  class="btn btn-outline btn-primary btn-sm"
>
  {{ "purchase.purchase-status-page-link.check-status" | translate }}
</button>
